import React, { Component } from 'react';
import './SolicitudesClienteSinEnviar.css';
import { Link } from 'react-router-dom';
import { FaArrowCircleLeft } from 'react-icons/fa';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSolicitudesCompraClienteSinEnviar, clearErrors } from '../../../redux/actions/dataasistencialactions';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DataGrid, esES, GridToolbarQuickFilter } from '@mui/x-data-grid';

class SolicitudesClienteSinEnviar extends Component {
  componentDidMount() {
    this.props.getSolicitudesCompraClienteSinEnviar(this.props.match.params.clienteId);
  }

  render() {
    const { solicitudes, loadingdataasistencial } = this.props.dataAsistencial;
    const clienteId = this.props.match.params.clienteId;

    const rows = solicitudes.map((row) => ({ id: row.solicitudid, ...row }));

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <Tooltip title="Ver Solicitud">
            <IconButton
              size="small"
              component={Link}
              to={`/dashboard/perfilcliente/${clienteId}/solicitud/${params.row.solicitudid}`}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        )
      },
      { field: 'titulo', headerName: 'Titulo', flex: 1, minWidth: 120 },
      { field: 'area', headerName: 'Area', flex: 1, minWidth: 120 },
      { field: 'servicio', headerName: 'Servicio', flex: 1, minWidth: 120 }
    ];

    return (
      <Box>
        <div className="titulo_section">
          <div className="titulo_clientes">
            <h1 className="text-clientes">Mis Solicitudes de Compras Sin Enviar</h1>
            <hr className="clientes_separator" />
          </div>
          <div className="div_boton">
            <Link to={`/dashboard/perfilcliente/${clienteId}`} style={{ textDecoration: 'none' }}>
              <Tooltip title="Volver">
                <IconButton size="small">
                  <FaArrowCircleLeft color="#03178C" size={20} />
                </IconButton>
              </Tooltip>
            </Link>
          </div>
        </div>

        <div className="table_container">
          {loadingdataasistencial ? (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          ) : (
            <Box sx={{ height: 500, width: '100%', mt: 2, '& .MuiDataGrid-columnHeaders': { backgroundColor: 'primary.main', color: 'white' } }}>
              <DataGrid
                rows={rows}
                columns={columns}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                components={{
                  Toolbar: () => (
                    <Box p={1}>
                      <GridToolbarQuickFilter placeholder="Buscar..." />
                    </Box>
                  )
                }}
              />
            </Box>
          )}
        </div>
      </Box>
    );
  }
}

SolicitudesClienteSinEnviar.propTypes = {
  getSolicitudesCompraClienteSinEnviar: PropTypes.func.isRequired,
  dataAsistencial: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired
};

const mapActionsToProps = { getSolicitudesCompraClienteSinEnviar, clearErrors };

const mapStateToProps = (state) => ({
  dataAsistencial: state.dataAsistencial,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(SolicitudesClienteSinEnviar);